module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "credits h7 nimbus-sans underline-links"
  }, [_c('h6', {
    staticClass: "no-case"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.creditsVisible = !_vm.creditsVisible
      }
    }
  }, [_vm._v("Credits")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.creditsVisible),
      expression: "creditsVisible"
    }]
  }, [_vm._v("\n    Design & Art Direction by "), _c('a', {
    attrs: {
      "href": "http://spencerfenton.co.uk/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Spencer Fenton")]), _c('br'), _vm._v("\n    Photography by Chloe Tun Tun"), _c('br'), _vm._v("\n    Programming by "), _c('a', {
    attrs: {
      "href": "http://everettwilliams.info",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Everett Williams")]), _c('br'), _vm._v("\n    VR images by "), _c('a', {
    attrs: {
      "href": "http://www.universalassemblyunit.com",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Universal Assembly Unit")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4618e04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Credits.vue
// module id = 398
// module chunks = 1